import layoutHeaderAside from '@/layout/header-aside';

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV);

import accounts from './accounts';
import orders from './orders';
import manageCenter from './manageCenter';
import bookingSpace from './booking';
import proof from './proof';
import template from './template';
import invoice from './invoice';
import basicData from './basicData';
import procurement from './procurement';
import factoryProduction from './factoryProduction';
import factoryProductionAfter from './factoryProductionAfter';
import inventoryRouter from './inventoryRouter';
import memberTeamRouter from './memberTeamRouter';
import teamBSTRouter from './teamBSTRouter';
const UnionLogin = () => import('@/views/system/login/unionLogin.vue');

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/',
    redirect: {name: 'index'},
    component: layoutHeaderAside,
    children: [
      // 首页
      {
        path: 'index',
        name: 'index',
        meta: {
          title: '首页',
          auth: true,
        },
        component: _import('system/index'),
      },{
      //提示没有权限的页面

        path: 'no_permit_warning',
        name: 'no_permit_warning',
        meta: {
          title: '没有权限',
          auth: true,
        },
        component: _import('nopermit'),
      },
      // 系统 前端日志
      {
        path: 'log',
        name: 'log',
        meta: {
          title: '前端日志',
          auth: true,
        },
        component: _import('system/log'),
      },
      // 刷新页面 必须保留
      {
        path: 'refresh',
        name: 'refresh',
        hidden: true,
        component: _import('system/function/refresh'),
      },
      // 页面重定向 必须保留
      {
        path: 'redirect/:route*',
        name: 'redirect',
        hidden: true,
        component: _import('system/function/redirect'),
      }, {
        path: 'nevesContract/:id',
        name: 'contract',
        meta:{
          title:'合同详情',
        },
        component: _import('contract/userContract'),
      },
      ...accounts,
      ...orders,
      ...bookingSpace,
      ...manageCenter,
      ...proof,
      ...template,
      ...invoice,
      ...basicData,
      ...procurement,
      ...factoryProduction,
      ...inventoryRouter,
      ...factoryProductionAfter,
      ...memberTeamRouter,
      ...teamBSTRouter
    ],
  },
]

/*;
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: _import('system/login'),
  }, {
    path: '/unionLogin',
    name: 'unionLogin',
    component: UnionLogin,
  }
]

/**
 * 错误页面
 */
const errorPage = [
  {
    path: '*',
    name: '404',
    component: _import('system/error/404'),
  },
];

// 导出需要显示菜单的
export const frameInRoutes = frameIn;

// 重新组织后导出
export default [
  ...frameIn,
  ...frameOut,
  ...errorPage,
];
